<template>
    <button
        :type="type"
        :disabled="disabled"
        :class="['a-button-otg', themeClass]"
        @click="onClick"
    >
        <slot>
            {{ title }}
        </slot>
        <slot name="icon">
        </slot>
    </button>
</template>

<script>
import { computed } from '@vue/composition-api';

export default {
    name: 'AButtonOtg',
    props: {
        type: {
            type: String,
            default: 'button'
        },
        title: {
            type: String,
            default: ''
        },
        disabled: {
            type: Boolean,
            default: false,
        },
        theme: {
            type: String,
            default: 'primary',
            validator: val => ['primary', 'white', 'white-underline'].includes(val)
        }
    },
    setup(props, { emit }) {
        function onClick() {
            emit('onClick')
        }

        const themeClass = computed(() => `button-otg-${props.theme}`);

        return {
            onClick,
            themeClass
        }
    }
}
</script>

<style lang="scss" src="./themes.scss" />
